import { useEffect } from 'react';
import clsx from 'clsx';
import { useRuntimeEnvironment } from '@/hooks/useRuntimeEnvironment';

const toneClasses = {
  amber: 'bg-amber-500 text-amber-950 border-amber-600/30',
  violet: 'bg-violet-600 text-white border-violet-700/40',
  rose: 'bg-rose-600 text-white border-rose-700/40',
};

export function DevEnvironmentBanner() {
  const runtime = useRuntimeEnvironment();

  useEffect(() => {
    if (!import.meta.env.DEV || !runtime.showBanner) {
      document.title = document.title.replace(/^\[(Mock|Sandbox|Local dev|Production)\]\s*/, '');
      return;
    }
    const prefix = `[${runtime.label}]`;
    if (!document.title.startsWith(prefix)) {
      document.title = `${prefix} ${document.title.replace(/^\[(Mock|Sandbox|Local dev|Production)\]\s*/, '')}`;
    }
  }, [runtime.label, runtime.showBanner]);

  if (!import.meta.env.DEV || !runtime.showBanner) return null;

  return (
    <div
      role="status"
      className={clsx(
        'relative z-[60] border-b px-3 py-1.5 text-center text-xs font-semibold tracking-wide sm:text-sm',
        toneClasses[runtime.bannerTone],
      )}
    >
      <span className="uppercase">{runtime.label}</span>
      <span className="mx-2 hidden opacity-60 sm:inline">·</span>
      <span className="hidden font-normal opacity-95 sm:inline">{runtime.detail}</span>
      <span className="font-normal opacity-95 sm:hidden">{runtime.detail.split('·')[0]?.trim()}</span>
    </div>
  );
}
